// Generated by scripts/build-lucide-categories.js
export const LUCIDE_CATEGORY_ORDER = [
  {
    "id": "animals",
    "label": "Animals"
  },
  {
    "id": "emoji",
    "label": "Emoji"
  },
  {
    "id": "food-beverage",
    "label": "Food & Beverage"
  },
  {
    "id": "gaming",
    "label": "Gaming"
  },
  {
    "id": "nature",
    "label": "Nature"
  },
  {
    "id": "seasons",
    "label": "Seasons"
  },
  {
    "id": "sports",
    "label": "Sports"
  },
  {
    "id": "other",
    "label": "Other"
  }
];
export const LUCIDE_CATEGORY_MAP = {
  "animals": [
    "Bird",
    "Birdhouse",
    "Bone",
    "Bug",
    "Cat",
    "Dog",
    "Egg",
    "Fish",
    "Origami",
    "Panda",
    "PawPrint",
    "Rabbit",
    "Rat",
    "Shell",
    "Shrimp",
    "Snail",
    "Squirrel",
    "Turtle",
    "Worm"
  ],
  "emoji": [
    "Angry",
    "Annoyed",
    "Balloon",
    "BicepsFlexed",
    "ChessBishop",
    "ChessKnight",
    "ChessPawn",
    "ChessRook",
    "Frown",
    "HandFist",
    "HandMetal",
    "Heart",
    "Laugh",
    "LeafyGreen",
    "Meh",
    "PartyPopper",
    "Ribbon",
    "Salad",
    "Smile"
  ],
  "food-beverage": [
    "Apple",
    "Banana",
    "Barrel",
    "Bean",
    "Beef",
    "Beer",
    "BottleWine",
    "Cake",
    "CakeSlice",
    "Candy",
    "CandyCane",
    "Carrot",
    "ChefHat",
    "Cherry",
    "Citrus",
    "Coffee",
    "Cookie",
    "CookingPot",
    "Croissant",
    "CupSoda",
    "Dessert",
    "Donut",
    "Drumstick",
    "Egg",
    "EggFried",
    "Fish",
    "GlassWater",
    "Grape",
    "Ham",
    "Hamburger",
    "Hop",
    "HopOff",
    "IceCreamBowl",
    "IceCreamCone",
    "LeafyGreen",
    "Lollipop",
    "Martini",
    "Microwave",
    "Milk",
    "Nut",
    "Pizza",
    "Popcorn",
    "Popsicle",
    "Salad",
    "Sandwich",
    "Shell",
    "Snail",
    "Soup",
    "Torus",
    "Tractor",
    "Utensils",
    "UtensilsCrossed",
    "Wheat",
    "Wine"
  ],
  "gaming": [
    "Axe",
    "Bone",
    "BowArrow",
    "Box",
    "Boxes",
    "Castle",
    "ChessBishop",
    "ChessKnight",
    "ChessPawn",
    "ChessRook",
    "CircleStar",
    "Clover",
    "Club",
    "Coins",
    "Dices",
    "Droplet",
    "Feather",
    "Flame",
    "FlameKindling",
    "FlaskConical",
    "FlaskRound",
    "Flower",
    "Gamepad",
    "Gamepad2",
    "GamepadDirectional",
    "Gem",
    "Ghost",
    "Gift",
    "Goal",
    "Headphones",
    "Headset",
    "Heart",
    "Hourglass",
    "Joystick",
    "LandPlot",
    "Milestone",
    "Mountain",
    "Pickaxe",
    "Puzzle",
    "Rocket",
    "Scroll",
    "ScrollText",
    "Shapes",
    "Shield",
    "Shovel",
    "Skull",
    "Spade",
    "Sparkles",
    "Sprout",
    "Sword",
    "Swords",
    "Target",
    "VenetianMask",
    "Volleyball",
    "Wand",
    "WandSparkles"
  ],
  "nature": [
    "Binoculars",
    "Birdhouse",
    "Cannabis",
    "CannabisOff",
    "FlameKindling",
    "Flower",
    "Flower2",
    "Leaf",
    "Mountain",
    "MountainSnow",
    "Rose",
    "Shell",
    "Shovel",
    "Shrub",
    "Sprout",
    "Stone",
    "Tent",
    "TentTree",
    "TreeDeciduous",
    "TreePalm",
    "TreePine",
    "Trees"
  ],
  "seasons": [
    "Flower2",
    "Leaf",
    "Rose",
    "Snowflake",
    "Sun"
  ],
  "sports": [
    "CircleStar",
    "FishingHook",
    "HandFist",
    "LandPlot",
    "Volleyball"
  ],
  "other": [
    "Axe",
    "Gem",
    "Ghost",
    "Mountain",
    "PartyPopper",
    "Rocket",
    "Shield",
    "Snowflake",
    "Sparkles",
    "Sun",
    "Sword",
    "Swords",
    "Target",
    "Wand",
    "WandSparkles"
  ]
};
